import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function lookup(obj, path) {
  return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("delta_lang") || "en");

  useEffect(() => {
    localStorage.setItem("delta_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const value = useMemo(() => {
    const t = (key, vars) => {
      let s = lookup(translations[lang], key);
      if (s === undefined) s = lookup(translations.en, key);
      if (s === undefined) return key;
      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          s = s.replaceAll(`{${k}}`, String(v));
        });
      }
      return s;
    };
    const rtl = lang === "ar";
    return { lang, rtl, t, setLang, toggle: () => setLang(rtl ? "en" : "ar") };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
